import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconTextStyle({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M1.5 1.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2a.5.5 0 0 1-1 0v-2h-5v13H10a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1h1.5v-13h-5v2a.5.5 0 0 1-1 0v-2z"/>
        </svg>
    );
}

export default IconTextStyle;
